export const PRODUCT_SECTIONS = {
  loans: {
    key: 'loans',
    title: 'Микрозаймы',
    categorySlug: 'loans',
    categorySlugs: ['loans'],
    listPath: '/admin/products/loans',
    paths: ['/loans'],
    formVariant: 'loan',
    defaultTermUnit: 'day',
    heroEyebrow: 'Микрозайм',
    conditionFields: [
      { key: 'age', label: 'Возраст' },
      { key: 'citizenship', label: 'Гражданство' },
      { key: 'document', label: 'Документ' },
    ],
    showAdvantages: true,
    showConditions: true,
    showBottomMainInfo: false,
    freeformConditions: false,
    descriptionLabel: 'Описание',
    specsMode: 'loan',
  },
  'consumer-loans': {
    key: 'consumer-loans',
    title: 'Потреб. кредиты',
    categorySlug: 'consumer-loans',
    categorySlugs: ['consumer-loans'],
    listPath: '/admin/products/consumer-loans',
    paths: ['/consumer-loans'],
    formVariant: 'loan',
    defaultTermUnit: 'month',
    heroEyebrow: 'Потребительский кредит',
    conditionFields: [
      { key: 'age', label: 'Возраст' },
      { key: 'citizenship', label: 'Гражданство' },
      { key: 'collateral', label: 'Залог' },
    ],
    showAdvantages: true,
    showConditions: true,
    showBottomMainInfo: false,
    freeformConditions: false,
    descriptionLabel: 'Описание',
    specsMode: 'loan',
  },
  'collateral-loans': {
    key: 'collateral-loans',
    title: 'Кредиты под залог',
    categorySlug: 'collateral-loans',
    categorySlugs: ['collateral-loans'],
    listPath: '/admin/products/collateral-loans',
    paths: ['/collateral-loans'],
    formVariant: 'loan',
    defaultTermUnit: 'month',
    heroEyebrow: 'Кредит под залог',
    conditionFields: [
      { key: 'age', label: 'Возраст' },
      { key: 'citizenship', label: 'Гражданство' },
      { key: 'collateral', label: 'Залог' },
    ],
    showAdvantages: true,
    showConditions: true,
    showBottomMainInfo: false,
    freeformConditions: false,
    descriptionLabel: 'Описание',
    specsMode: 'loan',
  },
  'debit-cards': {
    key: 'debit-cards',
    title: 'Дебетовые карты',
    categorySlug: 'debit-cards',
    categorySlugs: ['debit-cards'],
    listPath: '/admin/products/debit-cards',
    paths: ['/cards'],
    formVariant: 'card',
    heroEyebrow: 'Дебетовая карта',
    conditionFields: [
      { key: 'age', label: 'Возраст' },
      { key: 'citizenship', label: 'Гражданство' },
      { key: 'currency', label: 'Валюта' },
    ],
    showAdvantages: false,
    showConditions: true,
    showBottomMainInfo: true,
    freeformConditions: false,
    descriptionLabel: 'Описание',
    specsMode: 'advantages',
  },
  'credit-cards': {
    key: 'credit-cards',
    title: 'Кредитные карты',
    categorySlug: 'credit-cards',
    categorySlugs: ['credit-cards'],
    listPath: '/admin/products/credit-cards',
    paths: ['/auto-loans'],
    formVariant: 'card',
    heroEyebrow: 'Кредитная карта',
    conditionFields: [
      { key: 'age', label: 'Возраст' },
      { key: 'citizenship', label: 'Гражданство' },
      { key: 'collateral', label: 'Залог' },
    ],
    showAdvantages: false,
    showConditions: true,
    showBottomMainInfo: true,
    freeformConditions: false,
    descriptionLabel: 'Описание',
    specsMode: 'advantages',
  },
  'settlement-accounts': {
    key: 'settlement-accounts',
    title: 'Расчётные счета',
    categorySlug: 'settlement-accounts',
    categorySlugs: ['settlement-accounts'],
    listPath: '/admin/products/settlement-accounts',
    paths: ['/settlement-accounts'],
    formVariant: 'settlement',
    heroEyebrow: 'Расчётный счёт',
    conditionFields: [],
    showAdvantages: false,
    showConditions: true,
    showBottomMainInfo: true,
    freeformConditions: true,
    descriptionLabel: 'Краткое описание',
    specsMode: 'advantages',
  },
  services: {
    key: 'services',
    title: 'Сервисы',
    categorySlug: 'services',
    categorySlugs: ['services'],
    listPath: '/admin/products/services',
    paths: ['/services'],
    formVariant: 'simple',
    heroEyebrow: 'Сервис',
    conditionFields: [],
    showAdvantages: false,
    showConditions: false,
    showBottomMainInfo: false,
    freeformConditions: false,
    descriptionLabel: 'Краткое описание',
    specsMode: 'service',
  },
  shops: {
    key: 'shops',
    title: 'Магазины',
    categorySlug: 'shops',
    categorySlugs: ['shops'],
    listPath: '/admin/products/shops',
    paths: ['/shops'],
    formVariant: 'shop',
    heroEyebrow: 'Магазин',
    conditionFields: [
      { key: 'shop_category', label: 'Категория' },
      { key: 'shop_activity', label: 'Деятельность магазина' },
      { key: 'shop_region', label: 'Регион' },
    ],
    showAdvantages: false,
    showConditions: false,
    showBottomMainInfo: false,
    freeformConditions: false,
    descriptionLabel: 'Краткое описание',
    specsMode: 'shop',
  },
  obuchenie: {
    key: 'obuchenie',
    title: 'Обучение',
    categorySlug: 'obuchenie',
    categorySlugs: ['obuchenie', 'education'],
    listPath: '/admin/products/obuchenie',
    paths: ['/obuchenie', '/Education'],
    formVariant: 'education',
    heroEyebrow: 'Обучение',
    conditionFields: [
      { key: 'age', label: 'Возраст' },
      { key: 'study_term', label: 'Срок обучения' },
      { key: 'citizenship', label: 'Гражданство' },
    ],
    showAdvantages: false,
    showConditions: true,
    showBottomMainInfo: false,
    freeformConditions: false,
    descriptionLabel: 'Краткое описание',
    specsMode: 'education',
  },
  jobs: {
    key: 'jobs',
    title: 'Вакансии',
    categorySlug: 'jobs',
    categorySlugs: ['jobs'],
    listPath: '/admin/products/jobs',
    paths: ['/Job'],
    formVariant: 'job',
    heroEyebrow: 'Вакансия',
    conditionFields: [
      { key: 'age', label: 'Возраст' },
      { key: 'employment', label: 'Занятость' },
      { key: 'payouts', label: 'Выплаты' },
    ],
    showAdvantages: false,
    showConditions: true,
    showBottomMainInfo: false,
    freeformConditions: false,
    descriptionLabel: 'Краткое описание',
    specsMode: 'job',
  },
};

export const getSectionByCatalogPath = (catalogPath) =>
  Object.values(PRODUCT_SECTIONS).find((section) => (section.paths || []).includes(catalogPath)) || null;
